import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { AutocompleteOption } from 'src/app/features/search/model/casing-auto-complete.model';

export class UpdateCasingDropdownDataAction {
  static readonly type = '[CasingSearch] Update Dropdown Data';
  constructor(public fieldName: keyof CasingDropdownDataStateModel, public dropdownData: Array<AutocompleteOption>) {}
}

export class ResetCasingDropdownStateAction {
  static readonly type = '[CasingDropdown] Reset State';
}

export interface CasingDropdownDataStateModel {
  casingMakeListData: Array<AutocompleteOption>;
  casingSizeListData: Array<AutocompleteOption>;
  casingTreadListData: Array<AutocompleteOption>;
  casingTreadWidthListData: Array<AutocompleteOption>;
  casingSeriesListData: Array<AutocompleteOption>;
}

const defaultState: CasingDropdownDataStateModel = {
  casingMakeListData: [],
  casingSizeListData: [],
  casingTreadListData: [],
  casingTreadWidthListData: [],
  casingSeriesListData: []
};

const getDefaultState = () => ({ ...defaultState });

@State<CasingDropdownDataStateModel>({
  name: 'casingDropdownData',
  defaults: getDefaultState()
})
@Injectable()
export class CasingDropdownDataState {
  constructor() {}

  @Action(UpdateCasingDropdownDataAction)
  updateDropdownData(context: StateContext<CasingDropdownDataStateModel>, { fieldName, dropdownData }: UpdateCasingDropdownDataAction) {
    context.patchState({
      [fieldName]: dropdownData
    });
  }

  @Action(ResetCasingDropdownStateAction)
  resetState({ patchState }: StateContext<CasingDropdownDataStateModel>) {
    patchState(getDefaultState());
  }

  @Selector()
  static state(state: CasingDropdownDataStateModel) {
    return state;
  }

  @Selector()
  static makes(state: CasingDropdownDataStateModel) {
    return state.casingMakeListData;
  }

  @Selector()
  static sizes(state: CasingDropdownDataStateModel) {
    return state.casingSizeListData;
  }

  @Selector()
  static treads(state: CasingDropdownDataStateModel) {
    return state.casingTreadListData;
  }

  @Selector()
  static treadWidths(state: CasingDropdownDataStateModel) {
    return state.casingTreadWidthListData;
  }

  @Selector()
  static series(state: CasingDropdownDataStateModel) {
    return state.casingSeriesListData;
  }
}
